<header class="flex header p-2">
  <h2>
    @if (concept; as existing) {
      {{ 'ExpenseConcept_Modal_EditTitle' | translateWF: 'Edit expense concept' }} · <span class="font-mono">{{ existing.code }}</span>
    } @else {
      {{ 'ExpenseConcept_Modal_NewTitle' | translateWF: 'New expense concept' }}
    }
  </h2>
  <p-button icon="pi pi-times" variant="text" (click)="onClose()" />
</header>

<section class="content">
  <form [formGroup]="form" class="flex flex-col gap-4">
    @if (!concept) {
      <small class="text-surface-500">{{ 'ExpenseConcept_Modal_Code_Auto' | translateWF: 'The code (EC-001…) is assigned automatically when you save.' }}</small>
    }

    <div class="flex gap-[0.5rem] items-start">
      <i class="pi pi-language mt-[3px]"></i>
      {{ 'Common_Spanish_Translate' | translateWF: 'Spanish Translate' }}
      <p-toggleswitch [formControl]="spanishTranslate" />
    </div>

    <div class="form-box">
      <label ariaRequired="true">{{ 'ExpenseConcept_Modal_Name' | translateWF: 'Name' }}</label>
      <p-inputgroup>
        <p-inputgroup-addon>EN</p-inputgroup-addon>
        <input pInputText formControlName="nameEn" class="w-full" [ngClass]="{ 'ng-invalid ng-dirty': form.controls.nameEn.invalid && form.controls.nameEn.touched }" />
      </p-inputgroup>
      @if (spanishTranslate.value) {
        <p-inputgroup class="mt-[1rem]">
          <p-inputgroup-addon>ES</p-inputgroup-addon>
          <input pInputText formControlName="nameEs" class="w-full" />
        </p-inputgroup>
      }
    </div>

    <div class="form-box-row">
      <p-checkbox formControlName="isActive" [binary]="true" inputId="expense-concept-active" />
      <label for="expense-concept-active">{{ fieldLabels.isActive | translateWF: 'Active' }}</label>
    </div>
    @if (concept?.isActive && !form.controls.isActive.value) {
      <p-message severity="warn" styleClass="w-full">
        <span class="text-sm">{{
          'ExpenseConcept_Modal_Deactivate_Hint' | translateWF: 'A concept used by an active GL account rule cannot be deactivated; deactivate those rules first.'
        }}</span>
      </p-message>
    }
  </form>
</section>

<footer>
  <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onClose()" />
  <p-button [label]="'Save' | translateWF: 'Save'" [loading]="isSaving()" (click)="onSave()" />
</footer>
